module.exports = {"id":"dp1_2l3q6","text":"Evaluating Information","instructions":"Who is responsible for checking AI-generated information before use?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"1.2","questionType":"PickOne","random":true,"options":[{"id":"dp1_2l3q6-a1","text":"The human user","score":3.7},{"id":"dp1_2l3q6-a2","text":"The AI provider","score":1.3},{"id":"dp1_2l3q6-a3","text":"The platform","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat1.2/l3q6.json
// module id = 954
// module chunks = 41